const cached = {};

export default function el(id) {
	if (cached[id]) {
		return cached[id];
	}

	cached[id] = document.getElementById(id);

	return cached[id];
}
